import states from 'states-us';

/** Full state name from 2-letter abbreviation (same data as states-us / webform state_codes). */
export default function getStateFullName(stateAbbr = '') {
  const raw = String(stateAbbr || '').trim();
  if (!raw) {
    return '';
  }
  const abbrev = raw.toUpperCase();
  if (abbrev.length === 2) {
    return states.find(entry => entry.abbreviation === abbrev)?.name || abbrev;
  }
  return raw;
}
